export default function Council2021Entries() {
    return (
        <table id="filetable">
        {/*Start Table*/}
        <tr>
          <th>Meeting Date</th>
          <th>Minutes</th>
          <th>Agenda</th>
        </tr>
        {/*Start File*/}
        <tr>
          <td>12-20-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-12-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>11-30-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-11-30-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>11-17-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-11-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>11-15-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-11-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>11-10-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-11-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-26-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-10-26-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-25-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-10-25-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-19-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-10-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-18-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-10-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>09-20-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-09-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>08-16-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-08-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>07-19-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-07-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>07-13-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-07-13-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>06-21-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-06-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>05-17-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-05-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>04-19-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-04-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>03-15-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-03-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>02-16-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-02-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>02-02-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-02-02-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>01-19-2021</td>
          <td>
            <a href="../docs/council/minutes/2021/2021-01-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
      </table>
    )
}